import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../AuthProvider/AuthProvider'
import EmployeeWrapper from 'Pages/Skeleton/WrapperAuth/EmployeeWrapper/EmployeeWrapper'
import { ProfileProvider } from 'Context/ProfileContext'
// import AdminWrapper from 'Pages/Skeleton/WrapperAuth/AdminWrapper/AdminWrapper'

const ProtectedAdmin = () => {
  const { isLocalAuth } = useAuth()

  switch (isLocalAuth) {
    case false:
      return <Navigate to='/login' />
    case true:
      return (
        <ProfileProvider>
          <EmployeeWrapper>
            <Outlet />
          </EmployeeWrapper>
        </ProfileProvider>
      )
    default:
      return <Navigate to='/login' />
  }

}

export default ProtectedAdmin
